import { format } from "date-fns-tz";
import { selectTourTrigramDisplayForTournamentId } from "selectors/Tour";
import { selectTournamentName } from "selectors/Tournament";
import {
  PickemName,
  UpcomingOptionContainer,
  TimeLeft,
  TournamentLogoContainer,
} from "./styles";
import { TournamentLogo } from "components/Logo/TournamentLogo";
import { useAppSelector } from "app/hooks";

interface Props {
  tournamentId: string;
  name: string;
  openTime: number;
}

export const UpcomingPickemOption = ({
  tournamentId,
  name,
  openTime,
}: Props) => {
  const openTimeText =
    "Opens: " + format(new Date(openTime), "dd/MM/yy HH:mm zzz");

  const tourTrigram = useAppSelector((state) =>
    selectTourTrigramDisplayForTournamentId(state, tournamentId)
  );

  const tournamentName = useAppSelector((state) =>
    selectTournamentName(state, tournamentId)
  );

  return (
    <UpcomingOptionContainer>
      <TournamentLogoContainer faded={true}>
        <TournamentLogo id={tournamentId} />
      </TournamentLogoContainer>
      <PickemName>
        {!!tourTrigram ? `${tourTrigram} ` : ""}
        {tournamentName} - {name}
      </PickemName>
      <TimeLeft>{openTimeText}</TimeLeft>
    </UpcomingOptionContainer>
  );
};
